// extracted by mini-css-extract-plugin
export default {"content":"styles_content__4APvP","input":"styles_input__VNwLO","titleWrapper":"styles_titleWrapper__ZrunO","errorMessage":"styles_errorMessage__Z8Cok"};